module.exports = __webpack_public_path__ + "static/media/34.26313a99.png";